import {useMutation, useQueryClient} from "react-query";
import {completeSession, startSession} from "../api/sessionApi";


export function useStartSession(authToken){
    return useMutation({
        mutationFn: (sessionData) => startSession(sessionData, authToken),
        enabled: !!authToken,
    })
}

export function useCompleteSession(authToken){
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (sessionId) => completeSession(sessionId, authToken),
        enabled: !!authToken,
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries(['stats']),
                queryClient.invalidateQueries(['project-stats']),
            ])
        },
    })
}
